var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"products"},[_c('h2',[_vm._v("Produits")]),_c('ProductsComponent',{staticClass:"exposition",staticStyle:{"justify-content":"center"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }